<template lang="pug">
router-link.back-button.--base-color.--underline-effect(
  :to="routeTo",
) &lt;&lt; {{ text }}
</template>

<script>
export default {
  name: 'back-button',
  props: {
    home: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    routeHome() {
      return { name: 'home' }
    },
    routeTo() {
      return this.home || this.noHistory ? this.routeHome : this.previousPath
    },
    text() {
      return this.home || this.noHistory ? 'home' : 'back'
    },
    noHistory() {
      return !this.$routeHistory.hasHistory
    },
    previousPath() {
      const previous = this.$routeHistory.previous
      return previous ? { path: previous } : this.routeHome
    },
  },
}
</script>

<style lang="sass">
.back-button
  display: inline-block
  margin-bottom: 0.5rem
  font-size: 1rem
  font-variant: all-small-caps

  &.--underline-effect
    --underline-effect-line-height: 2px
    background-position: bottom right
</style>
